/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Select as NativeSelect,
	SelectProps,
} from '@mantine/core';

// Styles
import classes from './Select.module.css';

// Icons
import { IconChevronDown } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
export type TSelectProps = SelectProps;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Select = (props: TSelectProps) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeSelect
			classNames={classes}
			withScrollArea={false}
			styles={{
				dropdown: { maxHeight: 200, overflowY: 'auto' },
			}}
			comboboxProps={{
				dropdownPadding: 8,
			}}
			rightSection={
				<IconChevronDown
					color="var(--mantine-color-igluPrimary-9)"
					stroke={1.5}
					style={{
						marginRight: '5px',
					}}
					size="18px"
				/>
			}
			rightSectionPointerEvents="none"
			size="lg"
			{...props}
		/>
	);
};
